import 'primeicons/primeicons.css';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.css';
import 'primeflex/primeflex.css';

import React, { useState, useEffect, useRef } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import Services from '../../service/Services';
import BtnCrearTipoActividad from './BtnCrearTipoActividad'
import BtnActualizarTipoActividad from './BtnActualizarTipoActividad'
import ConfirmBtn from './ConfirmBtn'
import '../../assets/css/DataTable.css';
import axios from 'axios';

const ConsultarTiposActividad = ({ permisosProp }) => {

    const [servicio, setServicio] = useState([]);
    const [loading, setLoading] = useState(true);

    const getServices = new Services();

    useEffect(() => {
        const source = axios.CancelToken.source()
        getServices.getTipoActividades().then(data => {
            if (data !== undefined) {
                setServicio(data)
                setLoading(false)
            }
        });

        return () => {
            if (source) {
                getServices.cancelRequest()
            }
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    var permisoActivityTypeCreate
    if (permisosProp[7].permisos[0] === "Crear") {
        permisoActivityTypeCreate = true
    } else {
        permisoActivityTypeCreate = false
    }
    var permisoActivityTypeUpdate
    if (permisosProp[7].permisos[1] === "Editar") {
        permisoActivityTypeUpdate = true
    } else {
        permisoActivityTypeUpdate = false
    }
    var permisoActivityTypeDelete
    if (permisosProp[7].permisos[2] === "Eliminar") {
        permisoActivityTypeDelete = true
    } else {
        permisoActivityTypeDelete = false
    }


    const Acciones = (rowData) => {

        return (
            <>
                {permisoActivityTypeUpdate ?
                    <BtnActualizarTipoActividad
                        idTipoActividadProp={rowData.id}
                        tipoActividadProp={rowData.nombretipoactividad}
                        idCategoryProp={rowData.categoria.id}
                        categoryProp={rowData.categoria.descripcion}
                        creadoporProp={rowData.creadopor}
                        fechacreacionProp={rowData.fechacreacion}
                        dataProp={servicio}
                    />
                    :
                    ""
                }
                {permisoActivityTypeDelete ?
                    <ConfirmBtn
                        titulo="Confirmar Eliminación"
                        mensaje="¿Está seguro de eliminar Actividad?, Recuerde que una vez se elimine, se borrará definitivamente del sistema"
                        accion="Eliminar"
                        clase="p-button-danger"
                        icono="pi pi-trash"
                        idTipoActividadProp={rowData.id}
                        tooltipProp="Eliminar"
                    />
                    :
                    ""
                }

            </>
        );
    }


    const [globalFilter, setGlobalFilter] = useState(null);
    const dt = useRef(null);

    const handleChange = (e) => {
        e.preventDefault();
    };

    const header = (
        <div className="headerTable">
            {permisoActivityTypeCreate ?
                <BtnCrearTipoActividad
                    dataProp={servicio}
                />
                :
                ""
            }
            {loading && <p>Cargando información...</p>}
            <div>
                <span className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Buscar..." className="p-column-filter" keyfilter={/^[^<>*!=°|(#$%&"_)+-.:;,/?¡¿'{}]+$/}
                        onCut={handleChange} onCopy={handleChange} onPaste={handleChange}
                    />
                </span>
            </div>
        </div>
    );

    var permisosAcciones
    if (permisoActivityTypeUpdate === false && permisoActivityTypeDelete === false) {
        permisosAcciones = false
    } else {
        permisosAcciones = true
    }

    return (
        <div className="datatable-responsive-demo">
            <div className="card">
                <DataTable ref={dt} value={servicio} className="p-datatable-responsive-demo" paginator rows={10} header={header} globalFilter={globalFilter}
                    emptyMessage="Tipo de actividad no registrada en el sistema" loading={loading}>
                    <Column className="columna" field="id" sortable header="Id Tipo Actividad" />
                    <Column className="columna" field="nombretipoactividad" sortable header="Actividad" />
                    <Column className="columna" field="categoria.descripcion" sortable header="Categoría" />
                    {permisosAcciones ?
                        <Column header="Acciones" body={Acciones} />
                        :
                        <Column />
                    }
                </DataTable>
            </div>
        </div>
    );
}

export default ConsultarTiposActividad

